import { Stack } from "@mui/system";
import AssetShareDatatable from "../../../../../Components/Shared/assets-share-datatable";
import { GetObject } from "../../../../../Redux/Reducers/redux-slice-asset";
import { useAppSelector } from "../../../../../Redux/redux-store";

function AssetSingleShares() {
    const asset = useAppSelector(GetObject);

    return (<Stack sx={{ minHeight: "calc(100vh - 129px)" }}>
        <AssetShareDatatable asset={asset} />
    </Stack>);
}

export default AssetSingleShares;
